import { ScrapEyesEvent } from "components/scrapEyeLabelling/types";
import { EventData, LabelData } from "src/store/api/generatedApi";

export const convertEventForApi = (
  event: ScrapEyesEvent
): { event: EventData; labels: LabelData[] } => {
  const labels: LabelData[] = [];

  if (event.material && event.material !== "unknown") {
    labels.push({ label_type: "material", label: event.material });
  }

  if (event.comment) {
    labels.push({ label_type: "comment", label: event.comment });
  }

  if (event.area) {
    labels.push({ label_type: "area", label: event.area });
  }

  return {
    event: {
      ...event,
      start: event.start.toISOString(),
      end: event.end.toISOString(),
      event_type: event.eventType,
    },
    labels,
  };
};
